export default async function ({ store, redirect }) {
  if (!store.state.esyoil.companyRating.ratingCount) {
    return store.dispatch("esyoil/fetchEsyoilRatingData");
  }
}
